import PropTypes from 'prop-types';
import React from 'react';
import { motion } from 'framer-motion';
// material
import {
  Box,
  Grid,
  Container,
  Typography,
  Slide,
  Stack,
  TextField,
  Button,
  Autocomplete,
  Checkbox,
  Switch
} from '@mui/material';
import { Icon } from '@iconify/react';
import { alpha, useTheme } from '@mui/material/styles';
import { toast } from 'react-hot-toast';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
// components
import arrowBackFilled from '@iconify/icons-eva/arrow-back-fill';
import RequestsPackage from './RequestPackage';
import RequestSPLPServices from './RequestSPLPService';

// ----------------------------------------------------------------------

RequestsSPLPServices.propTypes = {
  item: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
};

export default function RequestsSPLPServices({ user, item: items, handleClick }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [selectedService, setSelectedService] = React.useState({});

  return (
    <Stack direction="column" spacing={1}>
      <Box sx={{ pb: 2 }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography variant="h4">Pilihan Paket Layanan</Typography>
        </Stack>
      </Box>
      {/* {console.log('data', items)} */}
      <Box sx={{ pb: 2, mb: 2 }}>
        <Grid container spacing={3}>
          {!_.isEmpty(items) &&
            items.map((item) => (
              <Grid item xs={6} md={3} lg={3}>
                <RequestSPLPServices
                  item={item}
                  handleClick={() => {
                    if (selectedService.id === item.id) {
                      setSelectedService({});
                      handleClick({});
                    } else {
                      setSelectedService(item);
                      handleClick(item);
                    }
                  }}
                  selectedService={selectedService}
                />
              </Grid>
            ))}
        </Grid>
      </Box>
    </Stack>
  );
}
